import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'

export const useFloorDimentionsValidationSchema = () => {
	const { t } = useTranslation()

	const dimentionsSchema = yup.object({
		width: yup.number().min(100).max(1000).typeError(t('Must be a number')),
		height: yup.number().min(100).max(1200).typeError(t('Must be a number'))
	})

	return yupResolver(dimentionsSchema)
}
